import axios from "axios";

export const getAdminConfig = async () => {
  const res = await axios.get(`/config/admin-config/`, {
    withCredentials: true,
  });
  return res.data;
};

export const saveAdminConfig = async (payload) => {
  const res = await axios.post(`/config/admin-config/`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  });

  const data = res.data;

  if (data.success === false) {
    throw {
      response: {
        data: {
          message:
            data.error ||
            data.message ||
            "Failed to save configuration",
        },
      },
    };
  }

  return data;
};

export const updateAdminConfig = async (plantGuid, payload) => {
  return axios.put(`/config/admin-config/?plant_guid=${plantGuid}`, payload, {
    withCredentials: true,
  });
};
